import saSdk from '../../../services/service-awards-sdk';
import gcSdk from '../../../services/gift-code-sdk';
import cashierSdk from '../../../services/cashier-sdk';

import { Intent } from '@blueprintjs/core';

/*******************************************************************************
 * Initial state
 */
const initialState = {
    managers: [],
    externalContributors: [],
    internalContributors: [],
    excessiveContributors: false,
    contributorsLoading: false,
    teamMembers: [],
    emailSent: false,
    emailSending: false,
    emailId: '',
    emailType: '',
    searching: false,
    recipient: {},
    busySendingRecipientEmail: false,
    busySendingReminderEmail: false,
    busySendingExpirationEmail: false,
    busyGeneratingGiftCode: false,
    busyProcessingPoints: false,
    busyCancelReissuingGiftCode: false,
    toast: null,
    program: {},
    programLoading: false,
    programLoadingError: null
};

// Some default toast objects
const successToast = {
    message: '',
    intent: Intent.SUCCESS,
    icon: 'tick',
    timeout: 3000

};

const errorToast = {
    message: '',
    intent: Intent.DANGER,
    icon: 'warning-sign',
    timeout: 0
};
/*******************************************************************************
 * Non-async action types
 */
const SET_STATE = 'contributors/setState';


/*******************************************************************************
 * Reducer
 */
export default function recipientDetailReducer( state = initialState, action ) {

    //update sent at date/time for contributors when email sent
    if ( action.state && action.state.emailId && state.teamMembers && state.teamMembers.teamMembers ) {
        const updateEmail = state.teamMembers.teamMembers.findIndex( ( member ) => { return member.contributionId === action.state.emailId; } );
        const emailTypeSent = `${ action.state.emailType }SentAt`;
        if ( updateEmail !== -1 ) {
            state.teamMembers.teamMembers[ updateEmail ][ emailTypeSent ] = new Date();
        }
    }
    switch ( action.type ) {
        case SET_STATE: {
            return {
                ...state,
                ...action.state
            };
        }

        default:
            return state;
    }
}

/*******************************************************************************
 * Action creators
 */
function setState( state ) {
    return {
        type: SET_STATE,
        state
    };
}


export function loadContributors( recipientId ) {
    return ( dispatch ) => {
        dispatch( setState( {
            contributorsLoading: true
        } ) );
        saSdk.getContributors( recipientId )
            .then( ( contributors ) => {
                dispatch( setState( {
                    managers: contributors.managers,
                    externalContributors: contributors.external,
                    internalContributors: contributors.internal,
                    excessiveContributors: contributors.excessiveContributors,
                    contributorsLoading: false
                } ) );
            } )
            .catch( ( err ) => {
                let errorMessage = 'Unknown error occurred while loading contributors';
                if ( err && err.errors ) {
                    errorMessage = err.errors[ 0 ].message;
                }
                console.log( err );
                dispatch( setState( {
                    toast: {
                        ...errorToast,
                        message: errorMessage
                    },
                    contributorsLoading: false
                } ) );
            } );
    };
}

export function resendEmail( recipientId, contributionId, type ) {
    return ( dispatch ) => {
        dispatch( setState( {
            emailSent: false,
            emailSending: true,
            emailId: contributionId,
            emailType: type
        } ) );
    saSdk.resendEmail( recipientId, contributionId, type )
        .then( ( success ) => {
            if ( success.success === true ) {
                dispatch( setState( {
                    ...success,
                    emailSent: true,
                    emailSending: false,
                    toast: {
                        ...successToast,
                        message: `${ type.charAt( 0 ).toUpperCase() + type.slice( 1 ) } Email sent successfully`
                    }
                } ) );
                dispatch( loadContributors( recipientId ) );
            } else {
                if ( success.logs.length > 0 ) {
                    dispatch( setState( {
                        emailSent: true,
                        emailSending: false,
                        toast: {
                            ...errorToast,
                            message: success.logs[ 0 ].logMessage
                        }
                    } ) );
                } else {
                    dispatch( setState( {
                        emailSent: true,
                        emailSending: false,
                        toast: {
                            ...errorToast,
                            message: success.message
                        }
                    } ) );
                }
            }
        } )
        .catch( ( err ) => {
            console.log( err );
        } );
    };
}
export function searchContributors( searchString, recipientId ) {

    return ( dispatch ) => {
        dispatch( setState( {
            searching: true,
            teamMembers: []
        } ) );
    saSdk.searchContributors( searchString, recipientId )
        .then( ( teamMembers ) => {

            dispatch( setState( {
                teamMembers
            } ) );
            dispatch( setState( { searching: false } ) );
        } )
        .catch( ( err ) => {
            let errorMessage = 'Unknown error occurred while searching contributors';
            if ( err && err.errors ) {
                errorMessage = err.errors[ 0 ].message;
            }
            console.log( err );
            dispatch( setState( {
                toast: {
                    ...errorToast,
                    message: errorMessage
                },
                searching: false
            } ) );
        } );
    };
}

export function getRecipient( recipientId ) {

    return ( dispatch ) => {
        dispatch( setState( {
            searching: true
        } ) );
        return saSdk.getRecipient( recipientId )
        .then( ( recipient ) => {
            return saSdk.getProgram( recipient.programId  ).then( program => {
                dispatch( setState( {
                    program,
                    recipient,
                    searching: false
                } ) );
            } );
        } )
        .catch( ( err ) => {
            console.log( err );
        } );
    };
}
export function updateRecipient( programId, recipientId, data ) {
    return ( dispatch ) => {
        return saSdk.updateRecipient( recipientId, data ).then( ( result ) => {
            alert( result.message === 'Award Date Updated successfully' ? 'Recipient Updated' : result.message || result.code );
            dispatch( getRecipient( recipientId ) );
        } ).catch( ( err ) => {
            setState( {
                recipientsLoadingError: err
            } );
        } );
    };
}
export function deleteRecipient( recipientId ) {
    return ( dispatch ) => {
        return saSdk.deleteRecipient( recipientId ).then( () => {
            dispatch( setState( {
                toast: {
                    ...successToast,
                    message: 'Recipient Deleted'
                },
            } ) );
            return true;
        } ).catch( ( err ) => {
            console.error( err );
            dispatch( setState( {
                toast: {
                    ...errorToast,
                    message: err.message || err.errors[ 0 ].message || 'Error deleting recipient'
                }
            } ) );
            return false;
        } );
    };
}

export function reEmitEvent( recipientId ) {
    return ( dispatch ) => {
        return saSdk.reEmitEvent( { recipientId } ).then( response => {
            if ( response.errors.length > 0 ) {
                console.error( response.errors );
                dispatch( setState( {
                    toast: {
                        ...errorToast,
                        message: response.errors[ 0 ].message || 'Error emitting event'
                    }
                } ) );
            } else {
                dispatch( setState( {
                    toast: {
                        ...successToast,
                        message: 'Event emitted'
                    },
                } ) );
                dispatch( getRecipient( recipientId ) );
            }
        } ).catch( ( err ) => {
            console.error( err );
            dispatch( setState( {
                toast: {
                    ...errorToast,
                    message: err.message || err.errors[ 0 ].message || 'Error emitting event'
                }
            } ) );
        } );
    };
}

export function resendContributorEmails( recipientId, emailType ) {
    return ( dispatch ) => {
        return saSdk.resendContributorEmails( recipientId, emailType ).then( ( result ) => {
            if ( result.errors && result.errors.length > 0 ) {
                dispatch( setState( {
                    toast: {
                        ...errorToast,
                        message: result.errors[ 0 ].logMessage
                    }
                } ) );
            } else {
                dispatch( setState( {
                    toast: {
                        ...successToast,
                        message: 'Email process re-run'
                    }
                } ) );
            }
            dispatch( getRecipient( recipientId ) );
            dispatch( loadContributors( recipientId ) );
        } ).catch( ( err ) => {
            dispatch( setState( {
                toast: {
                    ...errorToast,
                    message: err.message || err.errors[ 0 ].message || 'Error sending emails'
                }
            } ) );
            dispatch( getRecipient( recipientId ) );
            dispatch( loadContributors( recipientId ) );
        } );
    };
}

export function award( programId, recipientId ) {
    return ( dispatch ) => {
        dispatch( setState( { busyGeneratingGiftCode: true, busyProcessingPoints: true } ) );

        saSdk.award( recipientId ).then( ( result ) => {
            if ( result.success ) {
                dispatch( setState( {
                    busyGeneratingGiftCode: false,
                    busyProcessingPoints: false,
                    toast: {
                        ...successToast,
                        message: 'Recipient awarded'
                    }
                } ) );
                dispatch( getRecipient( recipientId ) );
            } else {
                dispatch( setState( {
                    busyGeneratingGiftCode: false,
                    busyProcessingPoints: false,
                    toast: {
                        ...errorToast,
                        message: result.logs[ 0 ].logMessage
                    }
                } ) );
            }
        } );
    };
}

export function revertPoints( recipientId ) {
    return ( dispatch ) => {
        dispatch( setState( { busyProcessingPoints: true } ) );

        saSdk.revertPoints( recipientId ).then( ( result ) => {
            if ( result.success ) {
                dispatch( setState( {
                    busyProcessingPoints: false,
                    toast: {
                        ...successToast,
                        message: 'Reverted points'
                    }
                } ) );
                dispatch( getRecipient( recipientId ) );
            } else {
                dispatch( setState( {
                    busyProcessingPoints: false,
                    toast: {
                        ...errorToast,
                        message: result.logs[ 0 ].logMessage
                    }
                } ) );
            }
        } );
    };
}

export function forceRetryPoints( recipientId, cashierRewardId ) {
    return ( dispatch ) => {
        dispatch( setState( { busyProcessingPoints: true } ) );

        return cashierSdk.forceRetryProcessingReward( cashierRewardId ).then( ( result ) => {
            if ( result.eventState === 'COMPLETED' ) {
                dispatch( setState( {
                    busyProcessingPoints: false,
                    toast: {
                        ...successToast,
                        message: 'Deposited points - it make take a little time to reflect update'
                    }
                } ) );
                dispatch( getRecipient( recipientId ) );
            } else {
                dispatch( setState( {
                    busyProcessingPoints: false,
                    toast: {
                        ...errorToast,
                        message: `Unable to deposit points: ${ result.rewards[ 0 ].errorMessage }`
                    }
                } ) );
            }
        } ).catch( ( error ) => {
            console.error( error );
            dispatch( setState( {
                busyProcessingPoints: false,
                toast: {
                    ...errorToast,
                    message: 'Error depositing points'
                }
            } ) );
        } );
    };
}

export function inviteContributors( recipientId, contributors ) {
    return ( dispatch ) => {
        return saSdk.inviteContributors( contributors ).then( ( result ) => {
            if ( result.errors.length === 0 ) {
                dispatch( setState( {
                    toast: {
                        ...successToast,
                        message: `Successfully invited ${ result.contributors ? `${ result.contributors.length } ` : ' ' }contributors`
                    }
                } ) );
                dispatch( loadContributors( recipientId ) );
            }
            return result;
        } ).catch( ( error ) => {
            console.error( error );
            dispatch( setState( {
                toast: {
                    ...errorToast,
                    message: 'Error inviting contributors'
                }
            } ) );
            return error;
        } );
    };
}

export function sendRecipientEmail( programId, recipientId ) {
    return ( dispatch ) => {
        dispatch( setState( { busySendingRecipientEmail: true } ) );

        saSdk.sendEmail( recipientId, 'recipient' ).then( ( result ) => {
            if ( result.success ) {
                dispatch( setState( {
                    busySendingRecipientEmail: false,
                    toast: {
                        ...successToast,
                        message: 'Award/Celebration Email sent successfully'
                    }
                } ) );
                dispatch( getRecipient( recipientId ) );
            } else {
                dispatch( setState( {
                    busySendingRecipientEmail: false,
                    toast: {
                        ...errorToast,
                        message: result.errors[ 0 ].message
                    }
                } ) );
            }
        } );
    };
}

export function sendReminderEmail( programId, recipientId ) {
    return ( dispatch ) => {
        dispatch( setState( { busySendingReminderEmail: true } ) );

        saSdk.sendEmail( recipientId, 'reminder' ).then( ( result ) => {
            if ( result.success ) {
                dispatch( setState( {
                    busySendingReminderEmail: false,
                    toast: {
                        ...successToast,
                        message: 'Award/Celebration Reminder Email sent successfully'
                    }
                } ) );
                dispatch( getRecipient( recipientId ) );
            } else {
                dispatch( setState( {
                    busySendingReminderEmail: false,
                    toast: {
                        ...errorToast,
                        message: result.errors[ 0 ].message
                    }
                } ) );
            }
        } );
    };
}

export function sendExpirationEmail( programId, recipientId ) {
    return ( dispatch ) => {
        dispatch( setState( { busySendingExpirationEmail: true } ) );

        saSdk.sendEmail( recipientId, 'expiration' ).then( ( result ) => {
            if ( result.success ) {
                dispatch( setState( {
                    busySendingExpirationEmail: false,
                    toast: {
                        ...successToast,
                        message: 'Award/Celebration Expiration Email sent successfully'
                    }
                } ) );
                dispatch( getRecipient( recipientId ) );
            } else {
                dispatch( setState( {
                    busySendingExpirationEmail: false,
                    toast: {
                        ...errorToast,
                        message: result.errors[ 0 ].message
                    }
                } ) );
            }
        } );
    };
}

export function cancelAndReissue( programId, recipientId, giftCodeId, milestoneCode ) {
    return ( dispatch ) => {
        dispatch( setState( { busyCancelReissuingGiftCode: true } ) );

        gcSdk.getGiftCode( giftCodeId ).then( ( giftCode ) => {
            saSdk.cancelAndReissue( programId, giftCode, milestoneCode ).then( ( result ) => {
                if ( result.success ) {
                    saSdk.award( recipientId ).then( () => {
                        dispatch( setState( {
                            busyCancelReissuingGiftCode: false,
                            toast: {
                                ...successToast,
                                message: `Gift Code will be Reissued at Level ${ milestoneCode }`
                            }
                        } ) );

                        gcSdk.cancelGiftCode( giftCodeId ).then( () => {
                            dispatch( getRecipient( recipientId ) );
                        } ).catch( ( err ) => {
                            dispatch( setState( {
                                busyCancelReissuingGiftCode: false,
                                toast: {
                                    ...errorToast,
                                    message: result.errors[ 0 ].message
                                }
                            } ) );
                        } );
                    } );
                } else {
                    dispatch( setState( {
                        busyCancelReissuingGiftCode: false,
                        toast: {
                            ...errorToast,
                            message: result.errors[ 0 ].message
                        }
                    } ) );
                }
            } );
        } );

    };
}

export function refreshCriteriaMessage( recipientId ) {
    return ( dispatch ) => {
        saSdk.refreshCriteriaMessage( recipientId ).then( () => {
            dispatch( setState( {
                toast: {
                    ...successToast,
                    message: 'Refreshed criteria message'
                }
            } ) );
        } ).catch( ( err ) => {
            dispatch( setState( {
                toast: {
                    ...errorToast,
                    message: 'Error refreshing criteria message'
                }
            } ) );
        } );
    };
}

export function clearToast() {
    return ( dispatch ) => {
        dispatch( setState( { toast: null } ) );

    };
}


export function loadProgram( programId ) {
    return ( dispatch ) => {
        if ( programId ) {
            dispatch( setState( {
                programLoading: true,
                programLoadingError: null
            } ) );

            saSdk.getProgram( programId )
                .then( ( program ) => {
                    dispatch( setState( {
                        program,
                        programLoading: false
                    } ) );
                } )
                .catch( ( err ) => {
                    dispatch( setState( {
                        programLoading: false,
                        programLoadingError: err
                    } ) );
                } );
        }
    };
}
